/**
 * ردیابِ رفتارِ کاربر برای «مرکزِ کنترل»ِ ادمینِ اصلی (v2.142.0).
 * صفحه‌ها، کلیک روی دکمه/تب/لینک/منو (فقط **برچسبِ** آن — هرگز مقدارِ فیلدها) و ping هر ۳۰ ثانیه (آنلاین بودن).
 * هر ۱۰ ثانیه یک‌جا فرستاده می‌شود؛ خطا بی‌صدا نادیده گرفته می‌شود (ردیابی هرگز کارِ کاربر را خراب نمی‌کند).
 */
import api from "../api/client";

let queue = [];
let started = false;
let currentPath = "";

const push = (kind, label) => {
  queue.push({ kind, path: currentPath || window.location.pathname + window.location.search, label });
  if (queue.length > 300) queue = queue.slice(-300);
};

function flush() {
  if (!queue.length || !localStorage.getItem("sc_token")) return;
  const events = queue; queue = [];
  api.post("/api/v1/activity/events", { events }).catch(() => {});
}

const CLICKABLE = "button, a, [role=tab], [role=menuitem], [role=button], .ant-menu-item, .ant-segmented-item, "
  + ".ant-tabs-tab, .ant-dropdown-menu-item, .ant-select-item-option, .gx-nav-leaf";

function labelOf(el) {
  const t = (el.getAttribute("aria-label") || el.innerText || el.getAttribute("title") || "").replace(/\s+/g, " ").trim();
  if (!t) return null;
  // عنوانِ پنجره‌ای که کلیک داخلش بوده — «ثبت پرداخت» در «پرداخت حقوق — نسیم شریفی»
  const modal = el.closest(".ant-modal, .ant-drawer");
  const ctx = modal ? (modal.querySelector(".ant-modal-title, .ant-drawer-title")?.innerText || "").trim() : "";
  const s = ctx && ctx !== t ? `${t} ‹ ${ctx}` : t;
  return s.length > 120 ? `${s.slice(0, 119)}…` : s;
}

export function startTracker() {
  if (started) return;
  started = true;
  document.addEventListener("click", (e) => {
    const el = e.target?.closest?.(CLICKABLE);
    if (!el || el.closest("input, textarea")) return;
    const l = labelOf(el);
    if (l) push("click", l);
  }, true);
  setInterval(flush, 10000);
  setInterval(() => { if (document.visibilityState === "visible") push("ping", null); }, 30000);
  window.addEventListener("beforeunload", flush);
}

export function trackPage(path, label) {
  currentPath = path;
  push("page", label || path);
  push("ping", null);
}
